import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  TextField,
  IconButton,
  Typography,
} from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CancelIcon from "@material-ui/icons/Cancel";
import FieldLabel from "../../../components/common/label";
import { postWebService } from "../../../helpers/server";
import { useHistory, useLocation } from "react-router";
import ImageUpload from "../../../components/common/imageUpload";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";

const EstimationForm = () => {
  const ref = useRef();
  const { search, state } = useLocation();

  let claimId = search.split("=")?.[1];
  //   let claimId = 18728;
  const [formData, setFormData] = useState(new FormData());
  const [formValues, setFormValues] = useState({
    claimed_amount: state?.item?.claimed_amount,
    estimate_details: state?.item?.data?.inputs?.estimate_details,
    job_sheet_number: state?.item?.data?.inputs?.job_sheet_number,
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileObjects, setFileObjects] = useState([]);
  const [docObj, setDocObj] = useState({});
  const [isCompressing, setIsCompressing] = useState(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const photoChangeHandler = (keyname, file) => {
    setDocObj(file);
  };

  const handleFileChange = async (event) => {
    setIsCompressing(true);
    const fileListArray = Array.from(event.target.files);
  
    const compressedFiles = await Promise.all(
      fileListArray.map(async (file) => {
        // Check if the file is an image and exceeds the threshold size from compressionOptions
        if (file.type.includes("image") && file.size > compressionOptions.sizeThresholdKB * 1024) {
          try {
            // Compress the image
            const compressedFile = await imageCompression(file, compressionOptions);
            console.log(`Original size: ${(file.size / 1024).toFixed(2)} KB`);
            console.log(`Compressed size: ${(compressedFile.size / 1024).toFixed(2)} KB`);
  
            // Create a preview URL for the compressed image
            return {
              file: compressedFile,
              preview: URL.createObjectURL(compressedFile),
            };
          } catch (error) {
            console.error("Error while compressing image", error);
          }
        }
        // Return original file if not compressing
        return {
          file,
          preview: file.type.includes("image") ? URL.createObjectURL(file) : null,
        };
      })
    );
  
    setSelectedFiles((prevFiles) => [...prevFiles, ...compressedFiles]);
    setFileObjects((prevFiles) => [
      ...prevFiles,
      ...compressedFiles.map((fileObj) => fileObj.file),
    ]);
    event.target.value = null;
  
    compressedFiles.forEach((fileObj) => formData.append("files", fileObj.file));
    setFormData(formData);
    setIsCompressing(false);
  };  

  const handleDeleteFile = (index) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updatedFiles);

    const updatedFileObjects = fileObjects.filter((_, i) => i !== index);
    setFileObjects(updatedFileObjects);

    const newFormData = new FormData();
    updatedFileObjects.forEach((file) => newFormData.append("files", file));
    setFormData(newFormData);
  };
  const history = useHistory();
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("claimed_amount", formValues.claimed_amount);
    formData.append("estimate_details", formValues.estimate_details);
    formData.append("job_sheet_number", formValues.job_sheet_number);
    formData.append("estimate_document", docObj);
    fileObjects.forEach((file, i) =>
      formData.append(`mobile_damage_photos[${i}]`, file)
    );

    try {
      const response = await postWebService(
        `submit/estimate/${claimId}`,
        formData
      );
      if (response?.data?.success) {
        toast(response?.data?.data?.message);
        history.push("/dashboard");
      }
    } catch (err) {
      toast("Something went wrong,please try again");
    }
  };

  const compressionOptions = {
    maxSizeMB: 1, // Target size of the compressed image (in MB)
    maxWidthOrHeight: 1000, // Max width or height of the compressed image
    useWebWorker: true, // Use web worker for compression
    sizeThresholdKB: 500, // Compress only images larger than 500KB
  };  

  return (
    <div style={{ padding: "4rem", width: "80%" }}>
      <p style={{ fontSize: "2rem", fontWeight: "8px" }}>Repair Estimate</p>
      <Box
        component="form"
        onSubmit={handleSubmit}
        my={2}
        style={{ width: "100%" }}
      >
        <div
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div>
            <TextField
              fullWidth
              margin="normal"
              label="Estimate Amount"
              name="claimed_amount"
              value={formValues.claimed_amount}
              onChange={handleInputChange}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Estimate Details"
              name="estimate_details"
              value={formValues.estimate_details}
              onChange={handleInputChange}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Job Sheet Number"
              name="job_sheet_number"
              value={formValues.job_sheet_number}
              onChange={handleInputChange}
              required
            />
          </div>
          <div>
            <FieldLabel
              label={"Estimate Document (jpeg, png, and pdf)"}
              fieldValue={formValues.estimate_document}
            />
            <Button
              data-tip={`Please upload estimate in pdf format for instant approval`}
            >
              <ImageUpload
                title="Add Document"
                photoChangeHandler={photoChangeHandler}
                filename="estimate"
              />
            </Button>
            <FieldLabel
              label={"Damage Mobile Photo (Please upload atleast 5 images )"}
              fieldValue={""}
            />
            <input
              type="file"
              ref={ref}
              style={{ display: "none" }}
              accept=".png,.jpeg,.jpg,.webp,.svg,.pdf"
              multiple
              onChange={handleFileChange}
            />
            <Button
              variant="outlined"
              color="secondary"
              size="large"
              style={{
                marginTop: "1rem",
                marginBottom: "1rem",
                borderRadius: "1rem",
              }}
              onClick={() => ref.current.click()}
              startIcon={<AddCircleOutlineIcon />}
            >
              Add Files
            </Button>

            <Box display="flex" flexWrap="wrap" mb={2}>
              {selectedFiles.map((file, index) => (
                <Box
                  key={index}
                  position="relative"
                  m={1}
                  display="inline-block"
                  borderRadius={1}
                  style={{ border: "1px solid #dfe0e0", padding: "0.5rem" }}
                >
                  {file.preview ? (
                    <img
                      src={file.preview}
                      alt={`Selected ${index}`}
                      style={{
                        height: "100px",
                        width: "100px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <Typography variant="body2">{file.file.name}</Typography>
                  )}
                  <IconButton
                    size="small"
                    style={{
                      position: "absolute",
                      top: "0",
                      right: "0",
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                    }}
                    onClick={() => handleDeleteFile(index)}
                  >
                    <CancelIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </Box>
          </div>
        </div>
        {isCompressing && <Typography variant="body2">Compressing images, please wait...</Typography>}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          style={{ marginTop: "1rem", borderRadius: "1rem" }}
          disabled={
            !(
              formValues?.claimed_amount &&
              formValues?.estimate_details &&
              formValues?.job_sheet_number &&
              selectedFiles?.length > 4 &&
              selectedFiles?.length <= 12 &&
              !isCompressing
            )
          }
        >
          Submit Estimate
        </Button>

      </Box>
    </div>
  );
};

export default EstimationForm;
